import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useShipstyles } from '../context/ShipstyleContext';
import { UPLOAD_URL } from '../config/config';

function ReadyToShipStyles() {
  const { shipstyles, loading, error } = useShipstyles();
  const navigate = useNavigate();
  const location = useLocation();

  const handleStyleClick = (styleName) => {
    // Navigate to products page with category parameter
    const searchParams = new URLSearchParams();

    // Map style names to categories (you can customize this mapping)
    let categoryFilter = styleName;

    // Handle special mappings if needed
    if (styleName.toLowerCase().includes('saree')) {
      categoryFilter = 'Sarees';
    } else if (styleName.toLowerCase().includes('lehenga')) {
      categoryFilter = 'Lehengas';
    } else if (styleName.toLowerCase().includes('salwar') || styleName.toLowerCase().includes('kameez')) {
      categoryFilter = 'Salwar Kameez';
    } else if (styleName.toLowerCase().includes('gown')) {
      categoryFilter = 'Gowns';
    }

    searchParams.set('category', categoryFilter);
    const newUrl = `/products?${searchParams.toString()}`;

    // If already on products page, force reload by navigating away and back
    if (location.pathname === '/products') {
      navigate('/');
      setTimeout(() => {
        navigate(newUrl);
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      }, 50);
    } else {
      navigate(newUrl);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  if (loading) return <p className="text-center">Loading...</p>;
  if (error) return <p className="text-center text-red-500">{error}</p>;
  if (!shipstyles || shipstyles.length === 0)
    return <p className="text-center">No ship styles found.</p>;

  const mainStyle = shipstyles[0]; // First style as main
  const subStyles = shipstyles.slice(1, 5); // Next 4 as substyles (if exist)

  return (
    <section className="w-full max-w-[90%] mx-auto mt-14 px-4 max-md:mt-10 max-md:px-2">
      <header className="flex flex-col items-center mb-8 text-lg font-medium text-center text-neutral-700">
        <h2 className="font-medium text-neutral-700">Ready-to-Ship Styles</h2>
      </header>

      <div className="flex flex-col lg:flex-row gap-4 w-full">
        {mainStyle && (
          <div className="flex-1 relative">
            <div className="w-full h-full">
              <img
                src={`${UPLOAD_URL}/ship_styles/${mainStyle.image}`}
                alt={mainStyle.name}
                className="object-cover w-full h-full min-h-[400px] lg:min-h-[566px]"
              />
            </div>
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
              <button
                onClick={() => handleStyleClick(mainStyle.name)}
                className="text-sm font-medium text-center text-white bg-black bg-opacity-50 px-4 py-2 rounded whitespace-nowrap hover:bg-opacity-70 transition-all focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
                aria-label={`Shop ${mainStyle.name} collection`}
              >
                {mainStyle.name}
              </button>
            </div>
          </div>
        )}

        <div className="flex-1">
          <div className="grid grid-cols-2 gap-4 h-full">
            {subStyles.map((style) => (
              <div key={style.id} className="relative">
                <div className="w-full h-full">
                  <img
                    src={`${UPLOAD_URL}/ship_styles/${style.image}`}
                    alt={style.name}
                    className="object-cover w-full h-full min-h-[180px] lg:min-h-[275px]"
                  />
                </div>
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2">
                  <button
                    onClick={() => handleStyleClick(style.name)}
                    className="text-xs lg:text-sm font-medium text-center text-white bg-black bg-opacity-50 px-2 py-1 rounded whitespace-nowrap hover:bg-opacity-70 transition-all focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2"
                    aria-label={`Shop ${style.name} collection`}
                  >
                    {style.name}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ReadyToShipStyles;
